import jQuery from 'jquery';
import 'slick-carousel';

jQuery(function ($) {
    'use strict';

    const $cardCarousel = $('.card-carousel');

    $cardCarousel.each(function () {
        const mobileMql = window.matchMedia('(min-width: 961px)');
        const $carousel = $(this);
        const $carouselContainer = $carousel.find('.columns');

        if ($carousel.find('.card-carousel__card').length > 1) {
            mobileMql.addEventListener('change', function () {
                if (mobileMql.matches) {
                    if ($carouselContainer.hasClass('slick-init')) {
                        $carouselContainer.slick('unslick');
                        $carouselContainer.removeClass('slick-init');
                    }
                } else {
                    if (!$carouselContainer.hasClass('slick-init')) {
                        initMobileSlick();
                    }
                }
            });

            if (!mobileMql.matches) {
                initMobileSlick();
            }

            function initMobileSlick() {
                $carouselContainer.slick({
                    arrows: true,
                    dots: true,
                    // appendDots: $this.next('.page-cards__dots'),
                    autoplay: false,
                    infinite: true,
                    slidesToShow: 1,
                    responsive: [
                        {
                            breakpoint: 961,
                            settings: {
                                slidesToShow: 1,
                            },
                        },
                        {
                            breakpoint: 9999,
                            settings: 'unslick',
                        },
                    ],
                    variableWidth: true,
                    prevArrow: null,
                    nextArrow: $carousel.find('.slick-next'),
                });
            }
        }
    });
});
